import { useRouter } from 'next/router';

import { CallToActionKind } from '@/types';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import Icon from '@/components/common/iconedLinks/Icon';

import styles from './EmptyItemEspot.module.scss';

type Data = {
  img: string;
  title: string;
  desc: string;
  redirect: {
    url: string;
    description: string;
  }
}
export const EmptyItemEspot: React.FC<Data> = ({ img, title, desc, redirect }) => {
  const router = useRouter();
  const redirectTo = (redirectUrl: string) => {
    return router.push(redirectUrl);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Icon className={styles.icon} src={img} alt={title} width={150} height={150} />
        <span className={styles.title}>{title}</span>
        <span className={styles.description}>{desc}</span>
        <CallToActionContainer kind={CallToActionKind.SECONDARY} onClick={() => redirectTo(redirect.url)} className={styles.button}>
          {redirect.description}
        </CallToActionContainer>
      </div>
    </div>
  );
};

export default EmptyItemEspot;
